import { Button, Stack } from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import MediaPriceInfo from './media-price-info';
import { useCallback, useEffect, useState } from 'react';
import { fetchMediaPrices, uploadPrice } from 'shared/api/prices';
import { PriceInfoDto } from '@sr/dto';
import AddPriceDialog from 'components/Prices/add-price-dialog';
import { FormData } from 'components/Prices/price-form-data';
import { useSnack } from 'shared/ui/snack';
import { useAddMediaPrice, useMediaPrices } from 'entities/media/media-price';

type Props = {
  mediaId: number;
};

const MediaSuppliersPrices = (props: Props) => {
  const { mediaId } = props;
  const { items } = useMediaPrices({mediaId, options: {isActive: true}});
  const prices = items;
  const addMediaPrice = useAddMediaPrice();
  const { showError, showSuccess } = useSnack();

  const [addDialogOpen, setAddDialogOpen] = useState(false);

  const handleAddClick = () => {
    setAddDialogOpen(true);
  };

  const handleSubmit = (data: FormData) => {
    return addMediaPrice({ ...data,
      media: mediaId,
      companies: data.companies.join(','),
      mainFile: data.mainFile[0]
    })
      .then(() => {
        setAddDialogOpen(false);
        showSuccess('Прайс успешно загружен');
      })
      .catch((e) => {
        showError(e.message);
      });
  };

  return (
    <>
      {prices && (
        <Stack direction="column" spacing={1}>
          {prices.map((x, i) => (
            <MediaPriceInfo key={x.id} priceInfo={x}/>
          ))}
        </Stack>
      )}
      <Button variant="contained" startIcon={<AddIcon />} onClick={handleAddClick}>
        Добавить прайс
      </Button>

      <AddPriceDialog open={addDialogOpen} onClose={() => setAddDialogOpen(false)} onSubmit={handleSubmit} />
    </>
  );
};

export default MediaSuppliersPrices;
